import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { AssetBriefAction } from '../../store/share.brief.functions';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { InverseButtonComponent } from '../buttons/inverse-button.component';

@Component({
    selector: 'action-bar',
    template: `
<div class="wrapper">
<div class="left-content" *ngIf="!!asset">
    <div class="asset">
      <icon *ngIf="!!asset.icon" [i12]="true" [icon]="asset.icon"></icon>
      <div class="name">{{ asset.name || 'Unnamed asset' }}</div>
    </div>
    <ng-container *ngIf="!!asset.sessions?.length">
      <h5>SESSIONS</h5>
      <div class="grey-text" *ngFor="let s of asset.sessions">{{ s.title || 'Untitled session' }} | {{ s.subTitle }}</div>
    </ng-container>
  </div>
  <div class="left-content" *ngIf="!!title">
    <div class="action-bar-title">{{ title }}</div>
    <ng-content select=".subtitle"></ng-content>
  </div>
  <div style="flex:1;"></div>
  <div class="right-content">
    <div *ngIf="state === 'complete'" class="complete">
      <icon [i18]="true" [icon]="'task_complete_24px'"></icon>
      {{ completedText }}
    </div>
    <div *ngIf="state === 'incomplete'" class="incomplete">
      <inverse-button (click)="buttonClick.emit()" [height]="'24px'" [warn]="true">
        {{ incompleteText }}
        <icon *ngIf="icon" [i12]="true" [icon]="icon"></icon>
      </inverse-button>
    </div>
    <div *ngIf="state === 'inProgress'" class="inProgress">
      {{ inProgressText }}
    </div>
  </div>
</div>
`,
    styleUrls: ['actionBar.scss'],
    standalone: true,
    imports: [IconComponent, CommonModule, InverseButtonComponent],
})
export class ActionBarComponent {
  @Input() title: string
  @Input() asset: AssetBriefAction
  @Input() completedText: string = 'Submitted'
  @Input() incompleteText: string
  @Input() inProgressText: string = 'Refresh to see the latest'
  @Input() state: ActionState
  @Input() icon = "OPEN_IN_NEW12"
  @Output() buttonClick: EventEmitter<void> = new EventEmitter()

}

export type ActionState = 'complete' | 'incomplete' | 'inProgress'